class drop_down_mp extends drop_down {

    constructor(select_id, template) {
        super(select_id, template);
        this.select_id = select_id;
        this.side = select_id.replace('mp_', '');
        this.fill_select();
        // this.format_mp_title();
    }

    fill_select() {
        var select = this.get_select();
        select[0].options.length = 0;
        for (var i = 0; i < mp_data.length; i++) {
            var class_list = [];
            select.append('<option data-i="' + i + '" class="' + class_list.join(' ') + '" value="' + mp_data[i].hahntype + '">' + mp_data[i].title + '</option>');
        }

    }

    update_visibility() {
        const selectEl = document.getElementById(this.select_id);
        if (!selectEl) {
            return;
        }

        const material = document.getElementById('material')?.value ?? '';
        const thread = document.getElementById('thread')?.value ?? '';
        var show = true, mp;
        this.showing = [];
        var mp_type = $("input[name='mp_" + this.side + "_type']:checked").val();
        let noneImgSrc = null;

        if (mp_type === 'none') {
            switch (material) {
                case 'staal':
                    noneImgSrc = this.side === 'cyl' ? texts.img_url + 'nogassprcylinder.jpg' : texts.img_url + 'nogassprrod.jpg';
                    break;
                case 'rvs':
                case 'rvs316':
                    noneImgSrc = this.side === 'cyl' ? texts.img_url + 'nogassprcylinderstainless.jpg' : texts.img_url + 'nogassprrod.jpg';
                    break;
            }
        }

        for (var i = 0; i < mp_data.length; i++) {
            show = true;
            mp = mp_data[i];

            if (mp.hahntype !== 'none') {
                if (mp.materiaal !== material) {
                    show = false;
                }
                if (mp.dschroefdraad !== thread) {
                    show = false;
                }
                if ((this.side === 'cyl' && mp.aanhuis !== '1') || (this.side === 'rod' && mp.aanstang !== '1')) {
                    show = false;
                }

                if (mp.aanconfig !== '1') {
                    show = false;
                }
            }

            if (mp_type && mp.type_aanbouwdeel.indexOf(mp_type) === -1 && mp_type !== 'none') {
                show = false;
            }

            const opt = selectEl.options[i];
            if (opt) {
                opt.classList.toggle('hidden', !show);
            }
            if (show) {
                this.showing.push(mp);
            }
        }

        if (noneImgSrc) {
            var imgElements = $('#mp_' + this.side + '-btn-flhtmls .flhtmls-li .flhtmls-li-img, #mp_' + this.side + '_0 .flhtmls-li-img');
            if (imgElements.length > 0) {
                imgElements.attr('src', noneImgSrc);
            }
        }

        /*
        If non visible part is selected, show standard or first one
         */
        const selectedOption = selectEl.options[selectEl.selectedIndex];
        if (selectedOption && selectedOption.classList.contains('hidden')) {
            var index = 0;
            for (var j = 0; j < this.showing.length; j++) {
                if ((this.showing[j].standardhuis === '1' && this.side === 'cyl') || (this.showing[j].standardstang === '1' && this.side === 'cyl')) {
                    index = j;
                    break;
                }
            }

            if (typeof (this.showing[index]) !== 'undefined') {
                $('#mp_' + this.side).val(this.showing[index].hahntype);
            }
        }

        // Disable opening the dropdown if there is only 1 visible result
        let visible = this.showing.length;
        if (visible === 1) {
            $('#mp_' + this.side).addClass('disabled-no-click');
            $('#mp_' + this.side + '-btn-flhtmls').addClass('disabled-no-click');
        } else {
            $('#mp_' + this.side).removeClass('disabled-no-click');
            $('#mp_' + this.side + '-btn-flhtmls').removeClass('disabled-no-click');
        }

        if (typeof (this.html_select) !== 'undefined') {
            this.html_select.sync();
        }

    }

    get_li_data(option_index) {
        // console.trace();
        var box4_text = "";
        var stock = "", img_src;
        var mp = mp_data[option_index];

        if (mp.hahntype !== 'none') {
            img_src = mp.dropdown_img_src;
        } else {
            var side = this.select_id.replace('mp_', '');
            var question_color = 'rgb(157 157 157)';

            switch (fd.get().material) {
                case 'staal':
                    img_src = side === 'cyl' ? texts.img_url + 'nogassprcylinder.jpg' : texts.img_url + 'nogassprrod.jpg';
                    question_color = 'rgb(157 157 157)';
                    break;
                case 'rvs':
                    img_src = side === 'cyl' ? texts.img_url + 'nogassprcylinderstainless.jpg' : texts.img_url + 'nogassprrod.jpg';
                    question_color = 'black';
                    break;
                case 'rvs316':
                    img_src = side === 'cyl' ? texts.img_url + 'nogassprcylinderstainless.jpg' : texts.img_url + 'nogassprrod.jpg';
                    question_color = 'black';
                    break;
                default:
                    img_src = '';
            }

            // set color of the question mark on top of the gas spring
            $('i.fl-icon-question-step-1-middle.fa.fa-question-circle').css('color', question_color);
        }
        var gs_wished_force = fd.get().gasspring_wished_force * 1;
        let mp_force = mp && mp.maxforceallowed ? mp.maxforceallowed : false;
        let mp_dikte = mp && mp.dikte ? mp.dikte : false;
        let mp_materiaal = mp && mp.materiaal ? mp.materiaal : false;
        let mp_gat = mp && mp.gat ? mp.gat : false;
        let mp_type_aanbouwdeel = mp && mp.type_aanbouwdeel ? mp.type_aanbouwdeel : false;
        let mp_schroefdraad = mp && mp.dschroefdraad ? mp.dschroefdraad : false;

        let mp_vorkafstand = mp && mp.vorkafstand ? mp.vorkafstand : false;
        let mp_kogeldiameter = mp && mp.kogeldiameter ? mp.kogeldiameter : false;
        const mp_length = mp && mp.elongationlength ? mp.elongationlength : false;

        // let mp_specs = mp.elongationlength + 'mm ';
        let mp_specs = '';

        // if (mp_type_aanbouwdeel) {
        //     mp_specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_typemp_text + '</span><span class="spec-value">' + mp_type_aanbouwdeel + '</span></div>';
        //     mp_specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_typemp_text + '</span><span class="spec-value">' + mp_type_aanbouwdeel + '</span></div>';
        // }

        if (mp_schroefdraad) {
            mp_specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_thread_text + '</span><span class="spec-value">M' + mp_schroefdraad + '</span></div>';
            mp_specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_thread_text + '</span><span class="spec-value">M' + mp_schroefdraad + '</span></div>';
        }

        if (mp_length) {
            mp_specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_length_text + '</span><span class="spec-value">' + mp_length + '&nbsp;mm</span></div>';
            mp_specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_length_text + '</span><span class="spec-value">' + mm_to_inch(mp_length) + '"</span></div>';
        }

        if (mp_force) {
            mp_specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_maxforceallowed_text + '</span><span class="spec-value">' + mp_force + '&nbsp;N</span></div>';
            mp_specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_maxforceallowed_text + '</span><span class="spec-value">' + newton_to_lbs(mp_force) + '&nbsp;lbs</span></div>';
        }

        if (mp_dikte) {
            mp_specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_thickness_text + '</span><span class="spec-value">' + mp_dikte + '&nbsp;mm</span></div>';
            mp_specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_thickness_text + '</span><span class="spec-value">' + mm_to_inch(mp_dikte) + '"</span></div>';
        }

        if (mp_gat) {
            mp_specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_hole_text + '</span><span class="spec-value">' + mp_gat + '&nbsp;mm</span></div>';
            mp_specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_hole_text + '</span><span class="spec-value">' + mm_to_inch(mp_gat) + '"</span></div>';
        }

        if (mp_kogeldiameter) {
            mp_specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_ball_dia_text + '<span class=\'diameter\'> &#8960;</span>:</span><span class="spec-value">' + mp_kogeldiameter + '&nbsp;mm</span></div>';
            mp_specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_ball_dia_text + '<span class=\'diameter\'> &#8960;</span>:</span><span class="spec-value">' + mm_to_inch(mp_kogeldiameter) + '"</span></div>';
        }

        if (mp_vorkafstand) {
            mp_specs += '<div class="product-spec metric"><span class="spec-label">' + texts.refine_fork_width_text + '</span><span class="spec-value">' + mp_vorkafstand + '&nbsp;mm</span></div>';
            mp_specs += '<div class="product-spec imperial"><span class="spec-label">' + texts.refine_fork_width_text + '</span><span class="spec-value">' + mm_to_inch(mp_vorkafstand) + '"</span></div>';
        }

        if (mp.price) {
            //var price = config_price_ex ? mp.price_ex : mp.price;
            var exchange_rate = price_format['exchangeRate'];
            var tax_rate = price_format['taxRate'];
            if (config_price_ex){
                price = mp.price_ex * exchange_rate;
            } else {
                price = mp.price_ex * exchange_rate * (1 + (tax_rate / 100));
            }

            mp_specs += '<div class="product-spec metric"><span class="spec-label-price">' + texts.refine_price + '</span><span class="spec-value-price">' + cf.format_price(price) + '</span></div>';
            mp_specs += '<div class="product-spec imperial"><span class="spec-label-price">' + texts.refine_price + '</span><span class="spec-value-price">' + cf.format_price(price) + '</span></div>';
        }

        // build buttons for refine!
        let mp_buttons = '';
        for (let i = 0; i < mp.cad_array.length; i++) {
            const cadpic = mp.cad_array[i];
            mp_buttons += '<button type="button" class="show_2d_cad_dd" aria-label="2D" data-cadpic="' + cadpic + ',' + this.select_id + '"></button>';
        }

        // mp.maxforceallowed
        // mp.dikte
        // mp.materiaal (staal/rvs/rvs316)
        // mp.gat (8.1)

        var price = config_price_ex ? mp.price_ex : mp.price;

        let return_data = {
            picture_src: img_src,
            title: this.format_mp_title(mp),
            specs: mp_specs,
            box4_text: box4_text,
            sku: texts.refine_sku_text + ' ' + mp.sku, // hahn type is temporarily for development purposes
            none: '',
            price: cf.format_price(price),
            diameter: mp.schroefdraad,
            stock: this.format_stock(mp, texts),
            id: this.select_id + '_' + option_index,
            button2dcyl: mp_buttons
        }

        // No mounting part selected
        if (mp.type_aanbouwdeel === 'none') {
            return_data.title = texts.no_mounting_part_selected;
            return_data.specs = {};
            return_data.sku = '';
            return_data.none = texts.no_mp_text;
        }

        return return_data;
    }
    
    /**
     * Process extensions for list items after they are created
     * This method should be called after the list items are populated
     */
    processExtensions() {
        if (typeof window.extensionHandler === 'undefined') {
            return;
        }

        var self = this;

        $('#' + this.select_id + '-flhtmls-ul li').each(function (index, element) {
            var $li = $(element);
            var liId = $li.attr('id') || '';
            var optionIndex = parseInt(liId.replace(self.select_id + '_', ''), 10);

            if (!isNaN(optionIndex) && mp_data[optionIndex]) {
                window.extensionHandler.processListItem($li, mp_data[optionIndex], self.select_id);
            }
        });
    }
    
    /**
     * Process extensions for the selected item
     * This method should be called after the selected item is updated
     * @param {number} selectedIndex - The index of the selected item
     * @param {string} selectId - The select ID (optional, defaults to this.select_id)
     */
    processSelectedItem(selectedIndex, selectId) {
        const finalSelectId = selectId || this.select_id;

        if (typeof window.extensionHandler === 'undefined' || !mp_data[selectedIndex]) {
            return;
        }

        const $selectedLi = $('#' + this.select_id + '-btn-flhtmls .flhtmls-li').first();
        const $ulLi = $('#' + this.select_id + '_' + selectedIndex);

        if ($selectedLi.length) {
            window.extensionHandler.processListItem($selectedLi, mp_data[selectedIndex], finalSelectId);
        }

        if ($ulLi.length) {
            window.extensionHandler.processListItem($ulLi, mp_data[selectedIndex], finalSelectId);
        }
    }

}
